import { useDetails } from '@/src/hooks/useDetails';
import { TokensWithMetadataAndAmount, getAssetOfUTxOs } from '@/src/lib/MayzSmartDB/Commons/index';
import { TokenMetadataApi } from '@/src/lib/MayzSmartDB/FrontEnd/index';
import { useAppStore } from '@/src/store/global';
import { UTxO } from '@lucid-evolution/lucid';
import { useEffect, useState } from 'react';

export const useDetailsBalance = ({ uTxOs }: { uTxOs: UTxO[] }) => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const loadDetails = async () => {
        const totalAssets = getAssetOfUTxOs(uTxOs);
        const assetDetails = await TokenMetadataApi.getAssetsWithDetailsApi(totalAssets);
        return assetDetails;
    };
    //--------------------------------------
    const { isLoadingDetails, isLoadedDetails, current, refreshDetails } = useDetails<TokensWithMetadataAndAmount>({ nameDetails: 'Balance', loadDetails });
    //--------------------------------------
    return {
        appStore,
        isRefreshing,
        isLoadingDetails,
        isLoadedDetails,
        current,
        refreshDetails,
    };
    //--------------------------------------
};
